import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const MODULE_STORAGE_KEY = 'trinity.dashboard.modules';

export const DEFAULT_EXPANDED = {
  health: true,
  users: true,
  signups: false,
  expiring: true,
  audit: false,
};

export const loadExpandedModules = () => {
  try {
    const raw = window.localStorage.getItem(MODULE_STORAGE_KEY);
    if (!raw) return { ...DEFAULT_EXPANDED };
    return { ...DEFAULT_EXPANDED, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_EXPANDED };
  }
};

export const saveExpandedModules = (state) => {
  try {
    window.localStorage.setItem(MODULE_STORAGE_KEY, JSON.stringify(state));
  } catch {
    // ignore quota / private mode
  }
};

const TrinityDashboardModule = ({ title, summary, expanded, onChange, children }) => (
  <Accordion
    expanded={expanded}
    onChange={(_, next) => onChange(next)}
    disableGutters
    elevation={0}
    TransitionProps={{ unmountOnExit: true }}
    sx={{
      mb: 2,
      border: '1px solid #E5E7EB',
      borderRadius: '8px !important',
      '&:before': { display: 'none' },
      bgcolor: '#fff',
      overflow: 'hidden',
    }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 2, minHeight: 56 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', pr: 1, flexWrap: 'wrap' }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        {summary ? (
          <Typography variant="body2" sx={{ color: '#6B7280' }}>
            {summary}
          </Typography>
        ) : null}
      </Box>
    </AccordionSummary>
    <AccordionDetails sx={{ px: 2, pb: 2, pt: 0 }}>{children}</AccordionDetails>
  </Accordion>
);

export default TrinityDashboardModule;
